import type React from 'react';
import styled from 'styled-components';

import { DotLoadingIndicator } from '@xing-com/dot-loading-indicator';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 40vw;
  width: 100%;
`;

export const ReducedJobDetailsLoading: React.FC = () => (
  <Container data-testid="reduced-job-details-loading">
    <DotLoadingIndicator />
  </Container>
);
